export const productsCode = ['CUCU', 'NUCU', 'MSUS', 'DFCU', 'SMCU']

export enum productsEnum {
  Nauta = 'NUCU',
  TOPUP = 'CUCU',
  SMS = 'MSUS',
  PACKAGE = 'DFCU',
  SIM = 'SMCU',
}
